import {SubscriptionPlanInfoResponse} from "../interface/subscriptionPlanInfoResponse";

export class SubscriptionInfoPaymentModel {

  subscriptionPlanData: SubscriptionPlanInfoResponse | any;
  isIndividuals: boolean;
  isStarter: boolean;
  isStandard: boolean;
  isYearly: boolean;
  startDate: Date;
  endDate: Date;

  constructor(
    subscriptionPlanData: SubscriptionPlanInfoResponse | any,
    isIndividuals: boolean = true,
    isStarter: boolean = false,
    isStandard: boolean = false,
    isYearly: boolean = false,
    startDate: Date,
    endDate: Date,
  ) {
    this.subscriptionPlanData = subscriptionPlanData;
    this.isIndividuals = isIndividuals;
    this.isStarter = isStarter;
    this.isStandard = isStandard;
    this.isYearly = isYearly;
    this.startDate = startDate;
    this.endDate = endDate;
  }
}
